import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yellowarrows",
  "use": "icon-yellowarrows-usage",
  "viewBox": "0 0 15 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 13\" id=\"icon-yellowarrows\">\r\n  <defs>\r\n    <style>\r\n      #icon-yellowarrows .cls-1 {\r\n        fill: #ffc592;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-yellowarrows_黄箭头\" class=\"cls-1\" d=\"M729.01,465.994l2.684-6.494-2.684-6.494,14.98,6.494Z\" transform=\"translate(-729 -453)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yellowarrows.svg
// module id = +gZI
// module chunks = 127